import {AnyAction} from 'redux';
import * as ModalActions from '../../actions/ModalActions';
import {defaultState} from '../state';
import {objectHasProperty} from '../../../common/utils/ValidationUtils';
import {ModalState} from '../../../common/types/reducers';
import * as UIActions from '../../actions/UIActions';
import * as LoginActions from '../../actions/LoginActions';

const modal = (state = defaultState.ui.modal, action: AnyAction): ModalState => {
    switch (action.type) {
        case ModalActions.CLOSE_MODAL_ACTION.name:
            return {
                ...defaultState.ui.modal
            };
        case ModalActions.OPEN_MODAL_DATA_ACTION.name:
            return {
                ...state,
                isVisible: true,
                header: action.header ? {
                    ...action.header,
                    closeBtn: objectHasProperty(action.header, 'closeBtn') ? action.header.closeBtn : true
                } : null,
                content: action.content,
                footer: action.footer,
                options: action.options
            };
        case LoginActions.LOGOUT_SUCCESS_ACTION.name:
        case UIActions.CLEAN_STATE_ACTION.name:
        case UIActions.INIT_APP_ACTION.name:
            return defaultState.ui.modal;
        default:
            return state;
    }
};

export default modal;